import { FC, useEffect, useRef, useState } from 'react'
import { useLayout } from '../../../_metronic/layout/core'
import SVG from 'react-inlinesvg'
import { Link, useHistory } from 'react-router-dom'
import { fleurSVGBlack } from '../../utils/constants'
import { shallowEqual, useSelector } from 'react-redux'
import { RootState } from '../../../setup'
import { UserRole } from '../../constants/roles'
import { hasRole } from '../../utils/permissions'
import { UserModel } from '../../modules/auth/models/UserModel'

const AddExperienceSuccessPage: FC = () => {
    const user = useSelector<RootState>(({ auth }) => auth.user, shallowEqual) as UserModel
    const { config, setLayout } = useLayout()
    const restoreRef = useRef(config)
    const history = useHistory()
    
    const isFinalUser = hasRole(user, UserRole.FINAL_USER);
    const isPartner = hasRole(user, UserRole.PARTNER);
    const isAdmin = hasRole(user, UserRole.STAFF_USER) || hasRole(user, UserRole.ADMIN);

    useEffect(() => {
        restoreRef.current = config

        setLayout({
            ...config,
            header: { ...config.header, display: true },
            aside: { ...config.aside, display: true },
            toolbar: { ...config.toolbar, display: false },
            footer: { ...config.footer, display: true },
        })

        return () => setLayout(restoreRef.current)
    }, [])

    return (<div className='tap-flex-center'>
        <div className="tap-add-experience-success-container">
            <div className="tap-add-experience-success-title">
                Your experience has been successfully submitted.
            </div>
            <div className="tap-add-experience-success-subtitle">
                Thank you for your active role in Nobilis. You’ll be notified once your experience is approved and visible to members—or if additional changes are required.
            </div>
            <div className="tap-add-experience-success-icon-wrapper">
                <div className='line-svg'>
                    <SVG src={'/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg'} />
                </div>
                <div className='icon-svg'>
                    <SVG src={fleurSVGBlack} />
                </div>
                <div className='line-svg'>
                    <SVG src={'/media/svg/nobilis/teams_and_partner/mask-success-line-icon.svg'} />
                </div>
                {/* <div className="tap-add-experience-success-icon" /> */}
            </div>
            {isFinalUser && (<div className="w-100 tap-flex-center">
                <Link to={'/user/my-experience'} className="tap-add-experience-success-btn-secondary">
                    <div>explore community</div>
                </Link>
            </div>)}
            {isPartner && (<div className="w-100 tap-flex-center">
                <Link to={'/partner/my-experiences'} className="tap-add-experience-success-btn-secondary">
                    <div>explore community</div>
                </Link>
            </div>)}
            {isAdmin && (<div className="w-100 tap-flex-center">
                <Link to={'/experience/admin'} className="tap-add-experience-success-btn-secondary">
                    <div>explore community</div>
                </Link>
            </div>)}
        </div>
    </div>)
}

export { AddExperienceSuccessPage }